import colors from 'vuetify/es5/util/colors'
var headerColor = '#FFFFFF'
var logo = '/assets/imgs/logo.svg'
var logoInverted = '/assets/imgs/logo-inverted.svg'
var logoHome = '/assets/imgs/logo-home.svg'
var background = '/assets/imgs/background.svg'
var backgroundLoading = '/assets/imgs/background-loading.svg'
var favicon = '/assets/imgs/favicon.svg'
var headerTextDark = false
var themes = {
  light: {
    primary: '#1A1883',
    secondary: '#FFFFFF',
    accent: '#2AB4DB',
    button: '#15252B',
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/background.svg')
    background = 'assets/imgs/' + localStorage.ambiente + '/background.svg'

    require('@/assets/imgs/' + localStorage.ambiente + '/background-loading.svg')
    backgroundLoading = 'assets/imgs/' + localStorage.ambiente + '/background-loading.svg'

    require('@/assets/imgs/' + localStorage.ambiente + '/logo.svg')
    logo = 'assets/imgs/' + localStorage.ambiente + '/logo.svg'

    require('@/assets/imgs/' + localStorage.ambiente + '/logo-inverted.svg')
    logoInverted = 'assets/imgs/' + localStorage.ambiente + '/logo-inverted.svg'

    require('@/assets/imgs/' + localStorage.ambiente + '/logo-home.svg')
    logoHome = 'assets/imgs/' + localStorage.ambiente + '/logo-home.svg'

    require('@/assets/imgs/' + localStorage.ambiente + '/favicon.svg')
    favicon = 'assets/imgs/' + localStorage.ambiente + '/favicon.svg'
  }
} catch {
  logo = '/assets/imgs/logo.svg'
  logoInverted = '/assets/imgs/logo-inverted.svg'
  logoHome = '/assets/imgs/logo-home.svg'
  background = '/assets/imgs/background.svg'
  backgroundLoading = '/assets/imgs/background-loading.svg'
  favicon = '/assets/imgs/favicon.svg'
}

switch (window.env.VUE_APP_AMBIENTE) {
  case 'btz':
    themes = {
      light: {
        primary: '#4D276F',
        secondary: '#D6D9DB',
        accent: '#2AB4DB',
        button: '#15252B',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
      dark: {
        primary: '#4D276F',
        secondary: '#333434',
        accent: '#2AB4DB',
        button: '#15252B',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
}

export default {
  dark: false,
  options: {
    customProperties: true,
    dense: false,
    toolbar: { color: headerColor, dark: headerTextDark },
  },
  themes: themes,
  logo: logo,
  logoInverted: logoInverted,
  background: background,
  logoHome: logoHome,
  favicon: favicon,
  backgroundLoading: backgroundLoading
}
